import { RelatedTagLink } from '@app/data/clients/shared/types';
import Box from '@redbubble/design-system/src/Box';
import { useViewportWidth } from '@redbubble/next/hooks';
import { DeviceType } from '@redbubble/next/types';
import { TagsList } from '../../../i/components/Tags/TagsList';
import type { Tag } from '../../../i/types';

interface SEOTagsProps {
  relatedTagLinks: RelatedTagLink[];
}

export const convertRelatedTagToTag = (
  relatedTags: RelatedTagLink[]
): Tag[] => {
  return relatedTags.map((relatedTag) => {
    return {
      name: relatedTag.title,
      linkSuffix: relatedTag.href,
      linkTitle: `Search for ${relatedTag.title}`,
      linkLabel: relatedTag.title,
      slug: relatedTag.href,
    };
  });
};

export const SEOTags: React.FC<SEOTagsProps> = ({ relatedTagLinks }) => {
  const mappedTags = convertRelatedTagToTag(relatedTagLinks);

  const { isOrAbove } = useViewportWidth();
  const isTablet = isOrAbove(DeviceType.Tablet);

  return (
    <Box>
      {mappedTags.length > 0 && (
        <TagsList tags={mappedTags} isTablet={isTablet} />
      )}
    </Box>
  );
};
